import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export enum GoldenDomeAppOrigin {
  SHOPIFY = "SHOPIFY",
}

const foreignIdSchema_ = z.object({
  origin: createEnum(GoldenDomeAppOrigin, {
    enumName: "golden_dome_app_origin",
  }),
  id: z.string(),
});

const goldenDomeAppSchema_ = z.object({
  _id: zExt.objectId(),
  foreignId: foreignIdSchema_,
  title: z.string(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const GoldenDomeAppSchema: z.ZodType<GoldenDomeApp> =
  goldenDomeAppSchema_;
export interface GoldenDomeApp extends z.infer<typeof goldenDomeAppSchema_> {}
